import { render, staticRenderFns } from "./material-category-add.vue?vue&type=template&id=099dc95a&scoped=true"
import script from "./material-category-add.vue?vue&type=script&lang=js"
export * from "./material-category-add.vue?vue&type=script&lang=js"
import style0 from "./material-category-add.vue?vue&type=style&index=0&id=099dc95a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099dc95a",
  null
  
)

export default component.exports